import { GlTooltipDirective, GlLink, GlIcon, GlSprintf } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __, sprintf } from '~/locale';
import UserAvatarLink from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/user_avatar/user_avatar_link.vue?vue3';
import timeagoMixin from '~/vue_shared/mixins/timeago';
import { RELEASED_AT_ASC, RELEASED_AT_DESC } from '~/releases/constants';
export default {
    name: 'ReleaseBlockDetails',
    components: {
        GlIcon,
        GlLink,
        GlSprintf,
        UserAvatarLink
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        timeagoMixin
    ],
    props: {
        commit: {
            type: Object,
            required: false,
            default: null
        },
        commitPath: {
            type: String,
            required: false,
            default: ''
        },
        tagName: {
            type: String,
            required: false,
            default: ''
        },
        tagPath: {
            type: String,
            required: false,
            default: ''
        },
        previousReleaseSha: {
            type: String,
            required: false,
            default: ''
        },
        comparePath: {
            type: String,
            required: false,
            default: ''
        },
        author: {
            type: Object,
            required: false,
            default: null
        },
        releasedAt: {
            type: Date,
            required: false,
            default: null
        },
        createdAt: {
            type: Date,
            required: false,
            default: null
        },
        sort: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        isSortedByReleaseDate () {
            return this.sort === RELEASED_AT_ASC || this.sort === RELEASED_AT_DESC;
        },
        timeAt () {
            return this.isSortedByReleaseDate ? this.releasedAt : this.createdAt;
        },
        atTimeAgo () {
            return this.timeFormatted(this.timeAt);
        },
        userImageAltDescription () {
            return this.author && this.author.username ? sprintf(__("%{username}'s avatar"), {
                username: this.author.username
            }) : null;
        },
        createdTime () {
            const now = new Date();
            const isFuture = now < new Date(this.timeAt);
            if (this.isSortedByReleaseDate) {
                return isFuture ? __('Will be released') : __('Released');
            }
            return isFuture ? __('Will be created') : __('Created');
        },
        releaseCommitTitle () {
            return sprintf(this.$options.i18n.releaseCommit, {
                commit: this.commit.title
            }, false);
        }
    },
    i18n: {
        dateString: __('%{action} %{date}'),
        releaseCommit: __('Release commit: %{commit}')
    }
};
